export default "__VITE_ASSET__Cfrh$CBR__"